import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const section = (theme: Theme) => css`
  padding: ${size[24]};
  display: flex;
  background-color: ${theme.palette.background.main};
  color: ${theme.palette.text.title};

  ${breakpoint.up('smMd')} {
    min-height: ${width.container.standard};
  }
`

export const dark = (theme: Theme) => css`
  background-color: ${theme.palette.background.accent};
  color: ${theme.palette.background.main};
`

export const content = css`
  max-width: ${width.container.compact};
  align-items: center;

  ${breakpoint.up('smMd')} {
    margin: 0 auto;
    max-width: ${width.container.large};
    padding: ${size[64]};
    display: grid;
    grid-template-columns: 2fr 1fr;
    column-gap: ${size[128]};
  }
`

export const title = css`
  font-size: ${pxToRem(32)};
  line-height: 1.2;
  max-width: ${width.modal.compact};

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
  }
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`

export const description = css`
  margin-top: ${size[24]};
  font-size: ${fontSize.md};
  line-height: 1.2;

  ${breakpoint.up('smMd')} {
    margin-top: ${size[40]};
  }
`

export const formWrapper = css`
  position: relative;
  z-index: 1;
`

export const formBg = css`
  position: absolute;
  top: -50%;
  left: ${size[32]};
  z-index: -1;
`

export const form = (theme: Theme) => css`
  margin-top: ${size[24]};
  padding: ${size[24]} ${size[16]};
  display: flex;
  flex-direction: column;
  gap: ${size[16]};
  background-color: ${theme.palette.background.main};
  border: 1px solid ${theme.palette.tertiary.lowContrast};
  border-radius: ${size[12]};
  box-shadow: ${theme.shadows.box};

  button {
    margin-top: ${size[18]};
  }

  ${breakpoint.up('smMd')} {
    margin-top: 0;
    padding: ${size[32]};
    min-width: ${width.container.small};
  }
`
